import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoujjaintempotraveller() {



  const cardData = {
"keyword": "Pune to Ujjain Tempo Traveller on Rent",

"headingDescription":
  "Aaradhya Travels offers reliable Pune to Ujjain Tempo Traveller on Rent for family trips, pilgrimage tours, group travel, corporate outings, and religious journeys. Our fleet includes comfortable 9, 12, 14, 17, and 20-seater tempo travellers equipped with air-conditioning, pushback seats, spacious interiors, luggage space, charging points, and experienced drivers skilled in long-distance highway travel. We ensure safe, comfortable, and punctual outstation travel from Pune to Ujjain with doorstep pickup and drop services.",

"topPlaces": [
  {
    "title": "Mahakaleshwar Jyotirlinga",
    "description":
      " is one of the twelve Jyotirlingas of Lord Shiva and the most famous spiritual destination in Ujjain for pilgrims."
  },
  {
    "title": "Ram Ghat",
    "description":
      " on the banks of the Shipra River is a sacred bathing and prayer site known for evening aarti and religious rituals."
  },
  {
    "title": "Harsiddhi Temple",
    "description":
      " is a revered Shakti Peetha known for its spiritual significance and traditional rituals."
  },
  {
    "title": "Kal Bhairav Temple",
    "description":
      " is a unique temple where offerings of liquor are traditionally made to Lord Bhairav."
  },
  {
    "title": "Shri Chintaman Ganesh Temple",
    "description":
      " is an ancient temple dedicated to Lord Ganesha and is popular among devotees seeking wish fulfillment."
  },
  {
    "title": "Sandipani Ashram",
    "description":
      " is believed to be the place where Lord Krishna received education from Guru Sandipani."
  },
  {
    "title": "Mangalnath Temple",
    "description":
      " is considered the birthplace of Mars (Mangal) and is important for astrological remedies."
  },
  {
    "title": "Vedh Shala (Jantar Mantar Ujjain)",
    "description":
      " is an ancient observatory used for astronomical studies and time calculations."
  },
  {
    "title": "ISKCON Ujjain",
    "description":
      " is a peaceful spiritual center dedicated to Lord Krishna with devotional activities and temple visits."
  },
  {
    "title": "Shipra River Ghats",
    "description":
      " are sacred riverbanks used for bathing rituals, festivals, and religious ceremonies in Ujjain."
  }
],



services: [
  {
    name: "Pune to Ujjain Tempo Traveller",
    description: "Pune to Ujjain tempo traveller service provides comfortable transportation for pilgrimage journeys, family vacations, group tours, and tourist travel requirements. Spacious seating and smooth highway travel ensure pleasant journeys suitable for long-distance travel. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient Pune to Ujjain tempo traveller reservations."
  },
  {
    name: "Ujjain Pilgrimage Tour from Pune",
    description: "Ujjain pilgrimage tour from Pune service offers dependable transportation for Mahakaleshwar temple visits, Jyotirlinga darshan, spiritual tours, and religious group travel. Comfortable seating and luggage space ensure smooth journeys suitable for pilgrims and family groups. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, temples, hotels, and residential areas across Pune. Flexible booking options allow convenient Ujjain pilgrimage tour reservations."
  },
  {
    name: "Pune to Ujjain AC Tempo Traveller",
    description: "Pune to Ujjain AC tempo traveller service provides premium air-conditioned transportation for pilgrimage journeys, family vacations, and tourist travel. Spacious seating and cooling systems ensure comfortable journeys suitable for long-distance highway travel. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and airports across Pune. Flexible booking options allow convenient AC tempo traveller reservations."
  },
  {
    name: "Pune to Ujjain Luxury Traveller",
    description: "Pune to Ujjain luxury traveller service offers premium transportation with modern interiors and spacious seating for religious tours, family outings, and executive travel. Smooth highway travel ensures pleasant journeys suitable for tourist groups and premium passengers. Professional chauffeurs ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient luxury traveller reservations."
  },
  {
    name: "Pune to Ujjain Group Travel",
    description: "Pune to Ujjain group travel service provides spacious transportation for pilgrimage groups, tourist travel, family tours, and corporate journeys. Comfortable seating and luggage capacity ensure smooth journeys suitable for medium and large passenger groups. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient group travel reservations."
  },
  {
    name: "Pune to Ujjain Outstation Traveller",
    description: "Pune to Ujjain outstation traveller service provides dependable long-distance transportation for pilgrimage tours, family vacations, sightseeing journeys, and group travel requirements. Spacious seating and smooth highway travel ensure comfortable journeys suitable for all passenger groups. Professional chauffeurs ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and airports across Pune. Flexible booking options allow convenient outstation traveller reservations."
  },
  {
    name: "Pune to Ujjain 17 Seater Tempo Traveller",
    description: "Pune to Ujjain 17 seater tempo traveller service offers spacious transportation for pilgrimage groups, family vacations, and tourist travel. Comfortable seating and premium interiors ensure pleasant journeys suitable for medium-sized passenger groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient 17 seater tempo traveller reservations."
  },
  {
    name: "Pune to Ujjain 20 Seater Traveller",
    description: "Pune to Ujjain 20 seater traveller service provides reliable transportation for religious tours, educational journeys, family trips, and group travel requirements. Spacious seating and luggage space ensure smooth journeys suitable for larger passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient 20 seater traveller reservations."
  },
  {
    name: "Pune to Ujjain 26 Seater Traveller",
    description: "Pune to Ujjain 26 seater traveller service offers spacious transportation for pilgrimage tours, wedding groups, corporate journeys, and sightseeing travel. Comfortable seating and smooth highway travel ensure pleasant journeys suitable for medium and large passenger groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, schools, and offices across Pune. Flexible booking options allow convenient 26 seater traveller reservations."
  },
  {
    name: "Pune to Ujjain 32 Seater Traveller",
    description: "Pune to Ujjain 32 seater traveller service provides luxury transportation for religious tours, tourist travel, educational trips, and group journeys. Spacious interiors and comfortable seating ensure smooth journeys suitable for large passenger groups. Professional chauffeurs ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, schools, offices, and residential areas across Pune. Flexible booking options allow convenient 32 seater traveller reservations."
  },
  {
    name: "Pune to Ujjain Family Trip",
    description: "Pune to Ujjain family trip service offers dependable transportation for holiday vacations, pilgrimage journeys, sightseeing tours, and family outings. Spacious seating and comfortable interiors ensure pleasant journeys suitable for local and outstation family group travel. Professional chauffeurs ensure reliable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, temples, and residential areas across Pune. Flexible booking options allow convenient family trip reservations."
  },
  {
    name: "Pune to Ujjain Religious Tour Bus",
    description: "Pune to Ujjain religious tour bus service provides spacious transportation for temple visits, Mahakaleshwar darshan, spiritual journeys, and group pilgrimage tours. Comfortable seating and luggage capacity ensure smooth journeys suitable for pilgrims and religious travel groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, temples, hotels, and residential areas across Pune. Flexible booking options allow convenient religious tour bus reservations."
  },
  {
    name: "Pune to Mahakaleshwar Temple Traveller",
    description: "Pune to Mahakaleshwar temple traveller service offers premium transportation for Jyotirlinga darshan, spiritual journeys, temple tours, and family pilgrimage travel. Spacious seating and smooth highway travel ensure comfortable journeys suitable for long-distance religious tours. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, temples, hotels, and residential areas across Pune. Flexible booking options allow convenient Mahakaleshwar traveller reservations."
  },
  {
    name: "Pune to Ujjain Night Travel Bus",
    description: "Pune to Ujjain night travel bus service provides dependable overnight transportation for pilgrimage tours, family journeys, tourist travel, and group trips. Comfortable seating and smooth highway travel ensure pleasant journeys suitable for long-distance overnight travel. Professional chauffeurs ensure reliable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient night travel bus reservations."
  },
  {
    name: "Pune to Ujjain Private Traveller Hire",
    description: "Pune to Ujjain private traveller hire service offers exclusive transportation for family vacations, religious tours, sightseeing trips, and business travel requirements. Spacious seating and premium interiors ensure comfortable journeys suitable for private passenger groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and airports across Pune. Flexible booking options allow convenient private traveller hire reservations."
  },
  {
    name: "Pune to Ujjain Affordable Tempo Traveller",
    description: "Pune to Ujjain affordable tempo traveller service provides economical transportation for pilgrimage journeys, tourist travel, educational tours, and group trips. Spacious seating and luggage space ensure comfortable travel experiences suitable for budget-friendly long-distance transportation requirements. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient affordable tempo traveller reservations."
  },
  {
    name: "Pune to Ujjain Premium Traveller Service",
    description: "Pune to Ujjain premium traveller service offers luxury transportation with spacious interiors and modern seating for pilgrimage tours, family vacations, and executive travel. Smooth highway journeys ensure pleasant travel suitable for tourist groups and premium passengers. Professional chauffeurs ensure punctual transportation and dependable pickup services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient premium traveller reservations."
  },
  {
    name: "Pune to Ujjain One Way Traveller",
    description: "Pune to Ujjain one way traveller service provides dependable one-side transportation for pilgrimage tours, tourist journeys, family travel, and business requirements. Spacious seating and comfortable interiors ensure smooth journeys suitable for local and outstation passenger movement. Professional chauffeurs ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and airports across Pune. Flexible booking options allow convenient one way traveller reservations."
  },
  {
    name: "Pune to Ujjain Round Trip Traveller",
    description: "Pune to Ujjain round trip traveller service offers complete return transportation for pilgrimage tours, sightseeing journeys, family vacations, and group travel requirements. Spacious seating and luggage capacity ensure comfortable travel experiences suitable for long-distance round trips. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient round trip traveller reservations."
  },
  {
    name: "Pune to Ujjain Weekend Tour Bus",
    description: "Pune to Ujjain weekend tour bus service provides spacious transportation for short holiday trips, pilgrimage journeys, family vacations, and tourist travel. Comfortable seating and smooth highway travel ensure pleasant journeys suitable for weekend travel groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, temples, and residential areas across Pune. Flexible booking options allow convenient weekend tour bus reservations."
  },
  {
    name: "Pune to Ujjain Group Booking",
    description: "Pune to Ujjain group booking service offers organized transportation for pilgrimage groups, tourist travel, educational tours, and family journeys. Spacious seating and premium interiors ensure smooth journeys suitable for medium and large passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, schools, offices, and residential areas across Pune. Flexible booking options allow convenient group booking reservations."
  },
  {
    name: "Pune to Ujjain Tourist Traveller",
    description: "Pune to Ujjain tourist traveller service provides dependable transportation for sightseeing tours, pilgrimage journeys, family vacations, and tourist group travel. Comfortable seating and luggage capacity ensure pleasant journeys suitable for local and long-distance travel requirements. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient tourist traveller reservations."
  },
  {
    name: "Pune to Ujjain AC Coach Hire",
    description: "Pune to Ujjain AC coach hire service offers premium air-conditioned transportation for pilgrimage groups, wedding travel, tourist journeys, and corporate trips. Spacious seating and cooling systems ensure comfortable travel suitable for all weather conditions. Professional chauffeurs ensure reliable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and schools across Pune. Flexible booking options allow convenient AC coach hire reservations."
  },
  {
    name: "Pune to Ujjain Wedding Group Travel",
    description: "Pune to Ujjain wedding group travel service provides luxury transportation for marriage ceremonies, guest transportation, family travel, and event journeys. Spacious seating and premium interiors ensure smooth journeys suitable for wedding celebrations and group travel requirements. Professional chauffeurs ensure punctual transportation and dependable pickup services throughout the route. Pickup services are available from homes, banquet halls, hotels, and residential areas across Pune. Flexible booking options allow convenient wedding group travel reservations."
  },
  {
    name: "Pune to Ujjain Corporate Travel Bus",
    description: "Pune to Ujjain corporate travel bus service offers spacious transportation for office staff, conferences, business meetings, employee outings, and executive travel requirements. Comfortable seating and modern interiors ensure pleasant journeys suitable for business passenger groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from offices, hotels, airports, and commercial hubs across Pune. Flexible booking options allow convenient corporate travel bus reservations."
  }
],

tableData: [
  ["Pune to Ujjain Tempo Traveller", "Ujjain Pilgrimage Tour from Pune"],
  ["Pune to Ujjain AC Tempo Traveller", "Pune to Ujjain Luxury Traveller"],
  ["Pune to Ujjain Group Travel", "Pune to Ujjain Outstation Traveller"],
  ["Pune to Ujjain 17 Seater Tempo Traveller", "Pune to Ujjain 20 Seater Traveller"],
  ["Pune to Ujjain 26 Seater Traveller", "Pune to Ujjain 32 Seater Traveller"],
  ["Pune to Ujjain Family Trip", "Pune to Ujjain Religious Tour Bus"],
  ["Pune to Mahakaleshwar Temple Traveller", "Pune to Ujjain Night Travel Bus"],
  ["Pune to Ujjain Private Traveller Hire", "Pune to Ujjain Affordable Tempo Traveller"],
  ["Pune to Ujjain Premium Traveller Service", "Pune to Ujjain One Way Traveller"],
  ["Pune to Ujjain Round Trip Traveller", "Pune to Ujjain Weekend Tour Bus"],
  ["Pune to Ujjain Group Booking", "Pune to Ujjain Tourist Traveller"],
  ["Pune to Ujjain AC Coach Hire", "Pune to Ujjain Wedding Group Travel"],
  ["Pune to Ujjain Corporate Travel Bus", "Pune to Ujjain Tempo Traveller"]
],





 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Ujjain Tempo Traveller on Rent",
        WhyChoosedescription: "Aaradhya Travels provides reliable Pune to Ujjain Tempo Traveller rental service with comfortable vehicles, professional drivers, and smooth travel arrangements for family trips, pilgrimage tours, and group travel."
      },
      {
        WhyChooseheading: "Affordable Tempo Traveller Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable Pune to Ujjain Tempo Traveller on rent with transparent pricing, flexible booking plans, and complete travel support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Tempo Traveller Booking Service",
        WhyChoosedescription: "Our Pune to Ujjain Tempo Traveller service operates 24 hours for Mahakaleshwar Jyotirlinga tours, family vacations, religious tours, group outings, and comfortable long-distance travel."
      },
      {
        WhyChooseheading: "Comfortable AC Tempo Travellers for Long Journeys",
        WhyChoosedescription: "All Tempo Travellers provided by Aaradhya Travels are spacious, air-conditioned, clean, and regularly maintained for safe and comfortable Pune to Ujjain group travel experiences."
      },
      {
        WhyChooseheading: "Customized Ujjain Tour Packages",
        WhyChoosedescription: "Aaradhya Travels offers customized Pune to Ujjain travel packages including Mahakaleshwar Darshan, Omkareshwar tours, Indore sightseeing, and multi-day pilgrimage travel plans."
      },
      {
        WhyChooseheading: "Multiple Seating Capacity Tempo Traveller Options",
        WhyChoosedescription: "Customers can choose from 13 seater, 17 seater, 20 seater, 26 seater, and luxury Tempo Travellers suitable for family groups, corporate teams, pilgrims, and tourist travel."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides convenient pickup from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Pimpri Chinchwad, Pune Airport, railway stations, hotels, and all major Pune locations."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Highway Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for Pune to Ujjain pilgrimage tours and outstation group transportation."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Ujjain Tempo Traveller on rent?", answer: "Pune to Ujjain Tempo Traveller rental service provides comfortable group transportation for Mahakaleshwar Darshan, pilgrimage tours, family travel, and outstation journeys." },
    { question: "Is Pune to Ujjain Tempo Traveller booking available 24 hours?", answer: "Yes, Aaradhya Travels provides 24/7 Pune to Ujjain Tempo Traveller rental service." },
    { question: "Which Tempo Traveller seating options are available?", answer: "Aaradhya Travels offers 13 seater, 17 seater, 20 seater, 26 seater, and luxury Tempo Travellers for Pune to Ujjain group travel." },
    { question: "Can I book Tempo Traveller for Mahakaleshwar Jyotirlinga Darshan?", answer: "Yes, customers can book Tempo Travellers for Mahakaleshwar Jyotirlinga Darshan, Omkareshwar tours, and complete Ujjain pilgrimage packages." },
    { question: "Are all Tempo Travellers air-conditioned?", answer: "Yes, all Tempo Travellers are fully air-conditioned and maintained for comfortable long-distance travel." },
    { question: "Can I book Tempo Traveller for family and group tours?", answer: "Yes, our Tempo Travellers are ideal for family vacations, religious groups, corporate outings, and tourist travel from Pune to Ujjain." },
    { question: "Can I book Pune to Ujjain Tempo Traveller online?", answer: "Yes, customers can easily book Pune to Ujjain Tempo Traveller service online or through phone booking." },
    { question: "Do you provide pickup from Pune Airport and railway station?", answer: "Yes, Aaradhya Travels provides airport, railway station, hotel, and home pickup service across Pune." },
    { question: "Are Tempo Traveller rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune to Ujjain Tempo Traveller service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and pilgrimage travel seasons." }
  ];

  const testimonials = [
  {
    id: 1,
    name: "Mr. Sunil Deshpande",
    feedback:
      "The Pune to Ujjain journey with Aaradhya Travels in a Tempo Traveller was long but very comfortable. The vehicle was well-maintained, and the group could travel together peacefully without any inconvenience.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Meena Kulkarni",
    feedback:
      "Aaradhya Travels arranged a Tempo Traveller for our Pune to Ujjain pilgrimage, and everything was managed very smoothly. The ride was comfortable for long hours, and the travel experience felt safe and organized.",
    rating: 5
  }
];

  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];
















  return (
    <div>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/93.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoujjaintempotraveller ;